import { useDispatch } from "react-redux";
import {
  EXLY_GLOBAL__CUSTOM_BACK_NAVIGATION,
  EXLY_GLOBAL__SET_PAGE_TITLE,
  EXLY_GLOBAL__SET_SHOW_APP_BAR,
  EXLY_GLOBAL__SET_SHOW_BOTTOM_NAV,
} from "redux/actions";

/**
 *
 * Any common app layout related utilities can be added here
 */
export const useAppLayoutUtils = () => {
  const dispatch = useDispatch();

  const resetAppLayout = () => {
    dispatch({ type: EXLY_GLOBAL__SET_PAGE_TITLE, payload: "" });
    dispatch({ type: EXLY_GLOBAL__SET_SHOW_APP_BAR, payload: true });
    dispatch({ type: EXLY_GLOBAL__SET_SHOW_BOTTOM_NAV, payload: true });
    dispatch({
      type: EXLY_GLOBAL__CUSTOM_BACK_NAVIGATION,
      payload: null,
    });
  };

  return {
    resetAppLayout,
  };
};
